module.exports = __webpack_public_path__ + "static/media/01-linkedin.4782db4e.svg";